import React, { useState, useEffect } from 'react';
import {createUserWithEmailAndPassword,
onAuthStateChanged} from "firebase/auth";
import {auth} from "../firebase-config";
import {db} from "../firebase-config";
import { collection, addDoc } from "firebase/firestore";
import Alert from 'react-bootstrap/Alert';
import Cookies from 'universal-cookie';

// export default class SignUp extends Component {
const SignUp = () => {
    
    const [isLoading, setLoading] = useState(false);
    const [ErrMessage, setErrMessage] = useState("");
    const [showError,setShowerror] = useState(false);
    
    const [registerEmail,setRegisterEmail] = useState("");
    const [registerPassword,setRegisterPassword] = useState("");
    const [registerName,setRegisterName] = useState("");
    const [registerLastname,setRegisterLastname] = useState("");
    const [stripe_id,setStripe_id] = useState("");
 
    const [user,setUser] = useState({});
    const usersCollectionRef = collection(db,"users");

      //ERROR
  const [error,SetError] = useState(false);
  const [errorMessage,SetErrorMessage] = useState("");
    
    useEffect(() => {
      onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);
        // console.log(user);
      });
    }, []) 

    const axios = require('axios').default;
    const header = {"Access-Control-Allow-Origin": "*",'content-type': 'application/x-www-form-urlencoded'}
    
    const register = async () => {
      try{
        setLoading(true);
        if(registerName.length<=0){
          setErrMessage("Error (Insert Name)");
          setShowerror(true);
          setLoading(false);
          return;
        }
        if(registerLastname.length<=0){
          setErrMessage("Error (Insert Last Name)");
          setShowerror(true);
          setLoading(false);
          return;
        }
        const user = await createUserWithEmailAndPassword(auth,registerEmail,registerPassword).then((res) => {
          console.log('User account created & signed in!', res.user.uid);
          var body = {
            'name': registerName + " " + registerLastname,
            'email': registerEmail
          };
          axios.post(process.env.REACT_APP_BACKEND+'createCustomer ', {
            body,header
          })
          .then(function (response) {
            if(response.data.result=="0"){
              SetError(true);
              SetErrorMessage(response.data.message);
              setLoading(false);
              return;
            }
            setStripe_id(response.data.id);
            createUser(res.user.uid,response.data.id);
          })
          .catch(function (error) {
            console.log(error);
          });
        });
        console.log(user);
      } catch (error){
        setErrMessage(error.message.replace("Firebase: ",""));
        setShowerror(true);
        setLoading(false);
      }
    };

    const createUser = async (uid,stripe_id) => {
      try {
        const userData = await addDoc(usersCollectionRef,{name:registerName,lastname:registerLastname,email:registerEmail,password:registerPassword,id: uid,club_name: "Sentinels Soccer Club",club_id: "sLpe9l6uT1eLS7yruI5j",main_user: "0",stripe_id: stripe_id,stripe_pm: ""}).then((res) => {
          const cookies = new Cookies();
          cookies.remove('player', { path: '/' });
          cookies.remove('player_name', { path: '/' });
          cookies.set('uid', uid, { path: '/' });
          cookies.set('email', registerEmail, { path: '/' });
          window.location = "/admin";
        });
      } catch (error) {
        setErrMessage(error.message.replace("Firebase: ",""));
        setShowerror(true);
        setLoading(false);
      }
    }

    useEffect(()=>{
        if(isLoading){
            document.getElementById("data").style.display = "none";
            document.getElementById("loader").style.display = "block";
        }else{
            document.getElementById("data").style.display = null;
            document.getElementById("loader").style.display = "none";
        }
    },[isLoading]);

    useEffect(()=>{
      if(showError){
        document.getElementById("error_alert").style.display = "block";
      }else{
        document.getElementById("error_alert").style.display = "none";
      }
    },[showError]);

    return (
      <div>
          <div className="auth-wrapper" id="data">
            <div className="auth-inner">
          <h3>Sign Up </h3>
          <div className="mb-3">
            <label>First name</label>
            <input
              type="text"
              className="form-control"
              placeholder="First name"
              value={registerName}
              onChange={(event)=>{setRegisterName(event.target.value)}}
            />
          </div>

          <div className="mb-3">
            <label>Last name</label>
            <input 
              type="text" 
              className="form-control" 
              placeholder="Last name"
              value={registerLastname}
              onChange={(event)=>{setRegisterLastname(event.target.value)}}
            />
            
          </div>

          <div className="mb-3">
            <label>Email address</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter email"
              value={registerEmail}
              onChange={(event)=>{setRegisterEmail(event.target.value)}}
            />
          </div>

          <div className="mb-3">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter password"
              value={registerPassword}
              onChange={(event)=>{setRegisterPassword(event.target.value)}}
            />
          </div>
          <div className="d-grid">
            <button onClick={register} className="btn btn-primary">
              Sign Up
            </button><br></br>
            {error && (
              <Alert key={"danger"} variant={"danger"}>
                {errorMessage}
              </Alert>
            )}
            <Alert key="danger" variant="danger" id="error_alert">
                {ErrMessage}
              </Alert>
          </div>
          <p className="forgot-password text-right">
            Already registered <a href="/sign-in">sign in?</a>
          </p>

        </div>
        </div>
        <div className="loader-container" id="loader">
            <div className="loader"></div>
        </div>
      </div>
    )
}

export default SignUp;